import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=7651a6be&scoped=true&"
import script from "./StudentCard.vue?vue&type=script&lang=js&"
export * from "./StudentCard.vue?vue&type=script&lang=js&"
import style0 from "./StudentCard.vue?vue&type=style&index=0&id=7651a6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7651a6be",
  null
  
)

export default component.exports